import axios from 'axios'

interface Message {
  role: 'system' | 'user' | 'assistant'
  content: string
}

export const getRequest = (backendBaseUrl: string, endpoint: string) => {
  return new Promise((resolve) => {
    console.log('\n\n\n\n backendBaseUrl:', backendBaseUrl)
    try {
      var config = {
        method: 'get',
        url: `${backendBaseUrl}/${endpoint}`,
        headers: {
          'Content-Type': 'application/json',
        },
      }

      axios(config)
        .then(function (response) {
          return resolve({ isData: true, response: response })
        })
        .catch(function (error) {
          console.log('\n getRequest request error:', error)
          return resolve({ isData: false, error: error })
        })
    } catch (err: any) {
      return resolve({ isData: false, error: err })
    }
  })
}

export const postRequest = (
  backendBaseUrl: string,
  endpoint: string,
  payload: any
) => {
  return new Promise((resolve, reject) => {
    console.log(
      '\n\n\n\n backendBaseUrl:',
      backendBaseUrl,
      '\n payload:',
      payload
    )
    try {
      var data = JSON.stringify(payload)
      var config = {
        method: 'post',
        url: `${backendBaseUrl}/${endpoint}`,
        headers: {
          'Content-Type': 'application/json',
        },
        data: data,
      }

      axios(config)
        .then(function (response) {
          return resolve(response)
        })
        .catch(function (error) {
          console.log('\n request error:', error)
          return reject(error)
        })
    } catch (err: any) {
      return reject(err)
    }
  })
}

export const postRequestWithFormData = (
  backendBaseUrl: string,
  endpoint: string,
  formData: FormData
) => {
  return new Promise((resolve, reject) => {
    try {
      var config = {
        method: 'post',
        url: `${backendBaseUrl}/${endpoint}`,
        headers: {
          'Content-Type': 'multipart/form-data',
        },
        data: formData,
      }

      axios(config)
        .then(function (response) {
          return resolve(response)
        })
        .catch(function (error) {
          console.log('\n postRequestWithFormData error:', error)
          return reject(error)
        })
    } catch (err: any) {
      return reject(err)
    }
  })
}

export const chatgptRequest = (
  apiUrl: string,
  apiKey: string,
  chatHistory: Message[]
) => {
  return new Promise(async (resolve, reject) => {
    try {
      const data = {
        messages: chatHistory,
        max_tokens: 500,
        temperature: 0.4,
        model: 'gpt-3.5-turbo',
      }
      /* const data =  {
              prompt: chatgptInput,
              max_tokens: 150,
              temperature: 0.7,
              model:'gpt-3.5-turbo'
            } */

      const response = await axios.post(apiUrl, data, {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${apiKey}`,
        },
      })
      return resolve(response)
    } catch (err: any) {
      return reject(err)
    }
  })
}

export const deleteRequest = (backendBaseUrl: string, endpoint: string) => {
  return new Promise((resolve) => {
    try {
      var config = {
        method: 'delete',
        url: `${backendBaseUrl}/${endpoint}`,
      }

      axios(config)
        .then(function (response) {
          return resolve({ isData: true, response: response })
        })
        .catch(function (error) {
          return resolve({ isData: false, error: error })
        })
    } catch (err: any) {
      return resolve({ isData: false, error: err })
    }
  })
}

export const putRequest = (
  backendBaseUrl: string,
  endpoint: string,
  payload: any
) => {
  return new Promise((resolve, reject) => {
    try {
      var data = JSON.stringify(payload)
      var config = {
        method: 'put',
        url: `${backendBaseUrl}/${endpoint}`,
        headers: {
          'Content-Type': 'application/json',
        },
        data: data,
      }

      axios(config)
        .then(function (response) {
          return resolve(response)
        })
        .catch(function (error) {
          return reject(error)
        })
    } catch (err: any) {
      return reject(err)
    }
  })
}
